import axios from '@axios'

const PREFIX = '/termos'

export default {
  /**
   * Retorna os termos pendentes de aceite para os tipos informados.
   * @param {number[]} tipos - Array de ETipoTermo (ex: [1] para NotificacaoCienciaEmailSmtp)
   * @param {string} [dataLimiteCriacao] - Filtro opcional: inclui apenas termos criados até esta data (ISO: 'yyyy-MM-dd')
   */
  getPendentes(tipos, dataLimiteCriacao) {
    return axios.get(`${PREFIX}/pendentes`, {
      params: { tipos, dataLimiteCriacao },
      // Necessário para que o axios serialize arrays como ?tipos=1&tipos=2
      paramsSerializer: params => {
        const searchParams = new URLSearchParams()
        if (params.tipos) {
          params.tipos.forEach(t => searchParams.append('tipos', t))
        }
        if (params.dataLimiteCriacao) {
          searchParams.append('dataLimiteCriacao', params.dataLimiteCriacao)
        }
        return searchParams.toString()
      },
    })
  },

  /**
   * Registra o aceite do termo pelo usuário autenticado.
   * @param {number} id - ID do termo aceito
   */
  aceitar(id) {
    return axios.post(`${PREFIX}/${id}/aceitar`)
  },
}
